import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ar from "../../language/Ar";
import en from "../../language/En";
import Loader from "../../common/loader";
import { MdDelete } from "react-icons/md";
import {
  deleteReport,
  deleteTicket,
  fetchReports,
  fetchTickets,
} from "../../redux/adminReducer";
import Modal from "../../common/modal";
import { toast } from "react-toastify";
import { postApi } from "../../api/axiosInstance";
import { API_PATH } from "../../api/apiPath";
function Ticket() {
  const { translations, dir } = useSelector((state) => state.language);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isRevertModalOpen, setIsRevertModalOpen] = useState(false);
  const [ticketMessage, setTicketMessage] = useState("");
  const [ticketToDelete, setTicketToDelete] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [filter, setFilter] = useState("all");
  const dispatch = useDispatch();

  const tickets = useSelector(
    (state) => state.admin.tickets?.data?.tickets || []
  );
  const totalTicketData = useSelector(
    (state) => state.admin.tickets?.data?.totalTickets || 0
  );

  useEffect(() => {
    setLoading(true);
    const b = {
      currentPage,
      filter,
    };
    dispatch(fetchTickets(b)).then(() => {
      setLoading(false);
    });
  }, [dispatch, currentPage, filter]);

  const handleDeleteClick = (ticket, e) => {
    e.stopPropagation();
    setTicketToDelete(ticket);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = () => {
    if (ticketToDelete) {
      setLoading(true);
      dispatch(deleteTicket(ticketToDelete._id))
        .then(() => {
          const b = {
            currentPage,
            filter,
          };
          dispatch(fetchTickets(b));
          toast.success(translations.toaster.service_deleted_successfully);
        })
        .catch((error) => {
          console.error("Delete failed", error);
        })
        .finally(() => {
          setLoading(false);
          setIsDeleteModalOpen(false);
          setTicketToDelete(null);
        });
    }
  };

  const openDetailView = (ticket) => {
    setIsModalOpen(true);
    setSelectedTicket(ticket);
  };

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalTicketData / itemsPerPage);

  const sendReportMail = async (id) => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await postApi(`${API_PATH.ADMIN.REVERT_TICKETS}/${id}`, {
        message: ticketMessage,
      });
      if (res.status === 201) {
        const b = {
          currentPage,
          filter,
        };
        dispatch(fetchTickets(b));
        setIsRevertModalOpen(false);
        setIsModalOpen(false);
        setTicketMessage("");
        setSelectedTicket(null);
        toast.success(translations.toaster.ticketrevertedsuccessfully);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Layout>
        <div className="min-h-screen w-full px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.ticket.tickets}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.ticket.ticketsManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1 ">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link
                  to="/"
                  className=" text-white  no-underline cursor-pointer"
                >
                  {translations.ticket.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300">
                  {translations.ticket.tickets}{" "}
                </span>
              </div>
            </div>
          </section>
          <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-2xl font-semibold text-white">
                    {translations.ticket.ticketList}
                  </h2>
                  <div className="flex items-center">
                    <label htmlFor="salon-status" className="text-white px-2">
                      {translations.ticket.filterBystatus} :
                    </label>
                    <div className="relative">
                      <select
                        id="report-status"
                        className="bg-gray-700 text-white rounded ps-2 pe-5 py-2 focus:outline-none w-full appearance-none"
                        value={filter}
                        onChange={(e) => {
                          setFilter(e.target.value);
                          setCurrentPage(1);
                        }}
                      >
                        <option value="all">{translations.ticket.all}</option>
                        <option value="pending">
                          {translations.ticket.pending}
                        </option>
                        <option value="resolved">
                          {translations.ticket.resolved}
                        </option>
                      </select>

                      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                        <svg
                          className="w-4 h-4 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                {tickets.length === 0 ? (
                  <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
                    <p className="text-xl">{translations.ticket.nodata}</p>
                  </div>
                ) : (
                  <>
                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white  rounded">
                        <thead className="bg-[#5A189A] text-white text-sm text-center">
                          <tr>
                            <th className="px-4 py-3">
                              {translations.ticket.ticketID}
                            </th>
                            <th className="px-4 py-3">
                              {translations.ticket.name}
                            </th>
                            <th className="px-4 py-3">
                              {translations.ticket.topic}
                            </th>
                            <th className="px-4 py-3">
                              {translations.ticket.createdBy}
                            </th>
                            <th className="px-4 py-3">
                              {translations.ticket.createdAt}
                            </th>
                            <th className="px-4 py-3">
                              {translations.ticket.status}{" "}
                            </th>
                            <th className="px-4 py-3">
                              {translations.ticket.actions}{" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-gray-800 text-white">
                          {tickets.map((ticket, index) => (
                            <tr
                              key={index}
                              className="text-center hover:bg-gray-700 cursor-pointer"
                              onClick={() => openDetailView(ticket)}
                            >
                              <td className="px-4 py-3">{ticket.ticketId}</td>
                              <td className="px-4 py-3">
                                {ticket.createdBy === "user"
                                  ? ticket?.userDetails?.name
                                  : ticket?.salonDetails?.business_name}
                              </td>
                              <td className="px-4 py-3">{ticket.ticket}</td>
                              <td className="px-4 py-3">{ticket.createdBy}</td>
                              <td className="px-4 py-3">
                                {new Date(ticket.createdAt).toLocaleDateString(
                                  "en-CA"
                                )}
                              </td>
                              <td className="px-4 py-3">
                                <span
                                  className={`bg-gray-600 px-4 py-1 rounded-full whitespace-nowrap capitalize ${
                                    ticket.status === "resolved"
                                      ? "text-green-600"
                                      : "text-yellow-500 "
                                  }`}
                                >
                                  {ticket.status}
                                </span>
                              </td>
                              <td className="px-4 py-3 flex justify-center">
                                <button
                                  onClick={(e) => handleDeleteClick(ticket, e)}
                                  className="text-red-700  hover:text-red-500  text-2xl"
                                >
                                  <MdDelete />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {/* Pagination Controls */}
                      <div className="mt-4 flex justify-between text-white">
                        <svg
                          className={`${
                            currentPage === 1
                              ? "fill-current"
                              : "cursor-pointer fill-current"
                          }
                        ${dir === "rtl" && "rotate-180"}`}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                          width={24}
                          height={24}
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          aria-disabled={currentPage === 1}
                        >
                          <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                        </svg>
                        <span>
                          {translations.ticket.page}
                          {totalPages > 1 ? (
                            <input
                              type="number"
                              name=""
                              id="pagination-jump"
                              className={
                                error
                                  ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                                  : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                              }
                              min={1}
                              max={totalPages}
                              defaultValue={currentPage}
                              onChange={(e) => e.target.value}
                              onBlur={(e) => handlePageChange(e)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  handlePageChange(e);
                                }
                              }}
                            />
                          ) : (
                            <span className="mx-1">{currentPage}</span>
                          )}
                          {translations.ticket.of} {totalPages}
                        </span>
                        <svg
                          className={`${
                            currentPage === totalPages
                              ? "fill-current"
                              : "cursor-pointer fill-current"
                          }
                        ${dir === "rtl" && "rotate-180"}`}
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 320 512"
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          aria-disabled={currentPage === totalPages}
                        >
                          <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                        </svg>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </Layout>
      {/* delete modal */}
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[40%] max-w-xl"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6 mx-auto text-white">
          <h2 className="text-xl font-semibold mb-4 text-red-600 text-center">
            {translations.ticket.confirmDelete}
          </h2>

          <p className="mb-6 text-center">{translations.ticket.warning}</p>

          <div className="flex flex-col sm:flex-row justify-end gap-3">
            <button
              className="w-full sm:w-auto bg-gray-500 px-4 py-2 rounded hover:bg-gray-400"
              onClick={() => setIsDeleteModalOpen(false)}
            >
              {translations.ticket.cancel}
            </button>
            <button
              className="w-full sm:w-auto bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
              onClick={() => {
                confirmDelete();
                setIsDeleteModalOpen(false);
              }}
            >
              {translations.ticket.delete}
            </button>
          </div>
        </div>
      </Modal>

      {/* Detail Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="w-[90%] max-w-4xl"
      >
        {selectedTicket && (
          <div className="text-white w-full max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header - Fixed */}
            <div className="flex items-center justify-between p-6 pb-4 border-b border-gray-600 flex-shrink-0">
              <h2 className="text-xl font-semibold text-white">
                {translations.ticket.ticketDetails}
              </h2>
              <div className="flex items-center gap-3">
                {selectedTicket.status === "pending" && (
                  <button
                    className="hover:text-primary transition-colors p-2 hover:bg-gray-700 rounded"
                    onClick={() => setIsRevertModalOpen(true)}
                    title="Send Email"
                  >
                    {/* Email Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="none"
                    >
                      <path
                        d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                )}
                {/* <button
                  className="hover:text-gray-300 transition-colors p-2 hover:bg-gray-700 rounded"
                  onClick={() => setIsModalOpen(false)}
                  title="Close"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M18 6L6 18M6 6l12 12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button> */}
              </div>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto p-6 space-y-6 scrollbar-hide ">
              {/* Basic Ticket Info Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                  <h4 className="font-semibold text-sm text-gray-300 mb-2">
                    {translations.ticket.ticketID}
                  </h4>
                  <p className="text-white font-mono">
                    {selectedTicket.ticketId}
                  </p>
                </div>
                <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                  <h4 className="font-semibold text-sm text-gray-300 mb-2">
                    {translations.ticket.status}
                  </h4>
                  <span
                    className={`inline-flex px-3 py-1 rounded-full text-sm font-medium capitalize ${
                      selectedTicket.status === "pending"
                        ? "bg-yellow-500/20 text-yellow-400 border border-yellow-500/30"
                        : selectedTicket.status === "resolved"
                        ? "bg-green-500/20 text-green-400 border border-green-500/30"
                        : "bg-gray-500/20 text-gray-400 border border-gray-500/30"
                    }`}
                  >
                    {selectedTicket.status}
                  </span>
                </div>
                <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                  <h4 className="font-semibold text-sm text-gray-300 mb-2">
                    {translations.ticket.reportedAt}
                  </h4>
                  <p className="text-white">
                    {new Date(selectedTicket.createdAt).toLocaleDateString(
                      "en-CA"
                    )}
                  </p>
                </div>
                <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                  <h4 className="font-semibold text-sm text-gray-300 mb-2">
                    {translations.ticket.reportedBy}
                  </h4>
                  <span
                    className={`inline-flex px-3 py-1 rounded-full text-sm font-medium capitalize ${
                      selectedTicket.createdBy === "user"
                        ? "bg-blue-500/20 text-blue-400 border border-blue-500/30"
                        : "bg-purple-500/20 text-purple-400 border border-purple-500/30"
                    }`}
                  >
                    {selectedTicket.createdBy}
                  </span>
                </div>
              </div>

              {/* Ticket Subject & Description */}
              <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                <h4 className="font-semibold text-sm text-gray-300 mb-3">
                  {translations.ticket.topic}
                </h4>
                <p className="text-white text-lg">{selectedTicket.ticket}</p>
              </div>

              <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                <h4 className="font-semibold text-sm text-gray-300 mb-3">
                  {translations.ticket.description}
                </h4>
                <p className="text-white leading-relaxed">
                  {selectedTicket.ticketDesc}
                </p>
              </div>

              {/* User/Salon Details */}
              {selectedTicket.createdBy === "user" &&
                selectedTicket.userDetails && (
                  <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                    <h4 className="font-semibold text-sm text-gray-300 mb-3">
                      {translations.ticket.userDetails}
                    </h4>
                    <div className="space-y-2">
                      <div className="flex items-center gap-2">
                        <span className="text-gray-400 text-sm">
                          {translations.ticket.name}:
                        </span>
                        <span className="text-white">
                          {selectedTicket.userDetails.name}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-gray-400 text-sm">
                          {translations.ticket.email}:
                        </span>
                        <span className="text-white">
                          {selectedTicket.userDetails.email}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span
                          className="text-gray-400 text-sm"
                          style={{ direction: "ltr" }}
                        >
                          {translations.ticket.phone}:
                        </span>
                        <span
                          className="text-white font-mono"
                          style={{ direction: "ltr" }}
                        >
                          {selectedTicket.userDetails.fullPhoneNumber}
                        </span>
                      </div>
                    </div>
                  </div>
                )}

              {selectedTicket.createdBy === "salon" &&
                selectedTicket.salonDetails && (
                  <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                    <h4 className="font-semibold text-sm text-gray-300 mb-3">
                      {translations.ticket.salonDetails}
                    </h4>
                    <div className="space-y-2">
                      <div className="flex items-center gap-2">
                        <span className="text-gray-400 text-sm">
                          {translations.ticket.business}:
                        </span>
                        <span className="text-white">
                          {selectedTicket.salonDetails.business_name}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-gray-400 text-sm">
                          {translations.ticket.email}:
                        </span>
                        <span className="text-white">
                          {selectedTicket.salonDetails.email}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span
                          className="text-gray-400 text-sm"
                          style={{ direction: "ltr" }}
                        >
                          {translations.ticket.phone}:
                        </span>
                        <span
                          className="text-white font-mono"
                          style={{ direction: "ltr" }}
                        >
                          {selectedTicket.salonDetails.business_phone}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-gray-400 text-sm">
                          {translations.ticket.country}:
                        </span>
                        <span className="text-white font-mono">
                          {selectedTicket.salonDetails.country_name}
                        </span>
                      </div>
                    </div>
                  </div>
                )}

              {/* Booking Details */}
              {selectedTicket.bookingDetails && (
                <div className="bg-gray-700/50 p-4 rounded-lg border border-gray-600">
                  <h4 className="font-semibold text-sm text-gray-300 mb-3">
                    {translations.ticket.bookingDetails}
                  </h4>
                  <div className="space-y-3">
                    {selectedTicket.createdBy === "salon" &&
                      selectedTicket.bookingDetails.user_id && (
                        <div className="bg-gray-600/50 p-3 rounded border border-gray-500">
                          <h5 className="text-blue-400 font-medium mb-2">
                            {translations.ticket.customerInformation}
                          </h5>
                          <div className="space-y-1">
                            <p className="text-white">
                              {selectedTicket.bookingDetails.user_id.name}
                            </p>
                            <p className="text-gray-300 font-mono text-sm">
                              {
                                selectedTicket.bookingDetails.user_id
                                  .fullPhoneNumber
                              }
                            </p>
                          </div>
                        </div>
                      )}

                    {selectedTicket.createdBy === "user" &&
                      selectedTicket.bookingDetails.salon_id && (
                        <div className="bg-gray-600/50 p-3 rounded border border-gray-500">
                          <h5 className="text-purple-400 font-medium mb-2">
                            {translations.ticket.salonInformation}
                          </h5>
                          <p className="text-white">
                            {
                              selectedTicket.bookingDetails.salon_id
                                .business_name
                            }
                          </p>
                        </div>
                      )}

                    {selectedTicket.bookingDetails.staff_id && (
                      <div className="bg-gray-600/50 p-3 rounded border border-gray-500">
                        <h5 className="text-green-400 font-medium mb-2">
                          {translations.ticket.staffMember}
                        </h5>
                        <p className="text-white">
                          {selectedTicket.bookingDetails.staff_id.name}
                        </p>
                      </div>
                    )}

                    <div className="bg-gray-600/50 p-3 rounded border border-gray-500">
                      <h5 className="text-orange-400 font-medium mb-2">
                        {translations.ticket.bookingDate}
                      </h5>
                      <p className="text-white font-mono">
                        {selectedTicket.bookingDetails.booking_date}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Footer - Fixed */}
            <div className="flex justify-end gap-3 p-6 pt-4 border-t border-gray-600 flex-shrink-0 bg-gray-800/50">
              <button
                className="bg-gray-600 hover:bg-gray-500 px-6 py-2 rounded-lg transition-colors font-medium"
                onClick={() => setIsModalOpen(false)}
              >
                {translations.ticket.close}
              </button>
            </div>
          </div>
        )}
      </Modal>
      {/* Revert Modal */}
      <Modal
        isOpen={isRevertModalOpen}
        onClose={() => setIsRevertModalOpen(false)}
        width="w-[400px]"
      >
        <div className="text-white p-6 bg-gray-800 rounded-lg">
          <h2 className="mb-4 text-xl font-semibold">Ticket Message</h2>
          <div className="mb-4">
            <textarea
              value={ticketMessage}
              rows={5}
              onChange={(e) => setTicketMessage(e.target.value)}
              placeholder={translations.ticket.enterticketmessage}
              className="w-full rounded-md border-[1.5px] border-dark-3 bg-gray-700 text-white px-4 py-2.5 focus:border-primary focus-visible:outline-none resize-none"
            />
          </div>
          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={() => setIsRevertModalOpen(false)}
              className="px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500"
            >
              {translations.ticket.cancel}
            </button>
            <button
              onClick={() => sendReportMail(selectedTicket._id)}
              disabled={!ticketMessage.trim()}
              className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {translations.ticket.submit}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Ticket;
